<script>
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrPicker',
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => ([])
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    validateCallback: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    /**
     * 数据改变方法
     */
    handleChange({ value }) {
      // 开始双向绑定数据
      this.$emit('input', value)
      this.$emit('change', value)
      // 关闭弹出框
      this.visible = false
      // 等页面渲染完成后开始校验数据
      this.$nextTick(this.validate)
    },

    /**
     * 点击关闭方法
     */
    handleCancel() {
      // 开始校验数据
      this.validate()
      // 通知父组件关闭事件
      this.$emit('close')
      // 关闭数据
      this.visible = false
    }
  },
  render() {
    // 取出当前选中的选项
    const option = this.options.find(option => option.value === this.value) || {}
    return (
      <div class='rnr-picker'>
        <van-field
          value={option.name}
          clearable={true}
          clear-trigger='always'
          clickable
          is-link
          label={this.label}
          required={this.required}
          readonly
          placeholder={`请选择${this.label}`}
          input-align='right'
          {...(this.attrs || {})}
          onClick={() => (this.visible = true)}
        />
        <van-action-sheet
          value={this.visible}
          actions={this.options}
          cancel-text='取消'
          onInput={visible => (this.visible = visible)}
          onClose={this.handleCancel}
          onSelect={this.handleChange}
        />
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormRender/picker.vue